// extracted by css-extract-rspack-plugin
export default {"actionBox":"CreateDocumentEntry_actionBox__OIl-W","canDrop":"CreateDocumentEntry_canDrop__Xyq56","dropzoneActive":"CreateDocumentEntry_dropzoneActive__lv90l"};